var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-outline-blue btn-rounded",attrs:{"href":_vm.actionUrl,"data-toggle":"modal","data-target":"#convertBPointsModal"},on:{"click":_vm.setupConversionForm}},[_vm._v(_vm._s(_vm.actionButtonTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }